module.exports = __webpack_public_path__ + "static/media/portal.ce8ebf92.jpg";